import { render, staticRenderFns } from "./Articulado_UnidadeObra.vue?vue&type=template&id=bcc7cb68"
import script from "./Articulado_UnidadeObra.vue?vue&type=script&lang=js"
export * from "./Articulado_UnidadeObra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports